import http from "../../../../services/api";
import { errorNotifier, successNotifier } from "../../../../components/NotificationHandler";

export const getSecurities = async (userId, skip = 0, limit = 6) => {
  try {
    const response = await http.get(`/admin/securities/${userId}?sort=desc&skip=${skip}&limit=${limit}&status=Active`);
    return response?.data?.result?.data?.securities || [];
  } catch (error) {
    errorNotifier(error.response?.data?.result?.message || "Failed to fetch securities");
    throw error;
  }
};

export const updateManagerPassword = async (userId, payload) => {
  try {
    const response = await http.put(`/manager/change-password/${userId}`, payload);
    const message = response?.data?.result?.message || "Password updated successfully";
    successNotifier(message);
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.result?.message || "Failed to update password";
    errorNotifier(errorMessage);
    throw error;
  }
};

export const updateSecurityPassword = async (userId, payload) => {
  try {
    const response = await http.put(`/manager/change-security-password/${userId}`, payload);
    const message = response?.data?.result?.message || "Security password updated successfully";
    successNotifier(message);
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.result?.message || "Failed to update security password";
    errorNotifier(errorMessage);
    throw error;
  }
};
